if (!customElements.get('best-sellers')) {
    class BestSellers extends HTMLElement {
      constructor() {
        super()

        let bestsellersSplideSlide = this.querySelectorAll('.bestsellers__splide__slide');

        let splide = new Splide(this.querySelector('.js-slider'), {
          type: 'loop',
          perMove: 1,
          pagination: false,
          arrows: true,
          slideFocus: false,
          perPage: 4,
          drag: true,
          gap: 0,
          speed: 800,
          breakpoints: {
            1200: {
              gap: 16,
              perPage: 3.5
            },
            1080: {
              gap: 16,
              perPage: 3
            },
            850: {
              gap: 16,
              perPage: 2.5
            },
            680: {
              gap: 16,
              perPage: 1.7
            }
          },
        });

        splide.mount();
      }
    }

    customElements.define('best-sellers', BestSellers)
  }
